import { defineStore } from 'pinia';
import { ref } from 'vue';

import { getMediaV2 } from '@/apis/library';
import MediaModel from '@/models/media';

export const useCropperStore = defineStore('cropper', () => {
  const adjustLinksPrompt = ref(false);
  const adjustTagsPrompt = ref(false);
  const adjustShoppingTagsPrompt = ref(false);
  const cropperRatio = ref(null);
  const cropperOriginalMedia = ref(null);
  const cropperZoom = ref(0);
  const videoDuration = ref(null);
  const isDragging = ref(false);

  async function getCropperOriginalMedia({ brandId, mediaId }) {
    const response = await getMediaV2({ brandId, mediaId });
    const payload = response?.data;
    if (payload) {
      cropperOriginalMedia.value = new MediaModel(payload);
    }
  }

  function setCropperRatio(cropperRatioValue) {
    cropperRatio.value = cropperRatioValue;
  }
  function removeCropperRatio() {
    cropperRatio.value = null;
  }
  function setAdjustLinksPrompt() {
    adjustLinksPrompt.value = true;
  }
  function removeAdjustLinksPrompt() {
    adjustLinksPrompt.value = false;
  }
  function setAdjustTagsPrompt() {
    adjustTagsPrompt.value = true;
  }
  function removeAdjustTagsPrompt() {
    adjustTagsPrompt.value = false;
  }
  function setAdjustShoppingTagsPrompt() {
    adjustShoppingTagsPrompt.value = true;
  }
  function removeAdjustShoppingTagsPrompt() {
    adjustShoppingTagsPrompt.value = false;
  }
  function removeCropperOriginalMedia() {
    cropperOriginalMedia.value = null;
  }
  function setCropperZoom(cropperZoomValue) {
    cropperZoom.value = cropperZoomValue;
  }
  function resetCropperZoom() {
    cropperZoom.value = 0;
  }
  function setVideoDuration(videoDurationValue) {
    videoDuration.value = videoDurationValue;
  }
  function removeVideoDuration() {
    videoDuration.value = null;
  }
  function setIsDragging(value) {
    isDragging.value = value;
  }

  return {
    adjustLinksPrompt,
    adjustTagsPrompt,
    adjustShoppingTagsPrompt,
    cropperRatio,
    cropperOriginalMedia,
    cropperZoom,
    videoDuration,
    isDragging,
    getCropperOriginalMedia,
    setCropperRatio,
    removeCropperRatio,
    setAdjustLinksPrompt,
    removeAdjustLinksPrompt,
    setAdjustTagsPrompt,
    removeAdjustTagsPrompt,
    setAdjustShoppingTagsPrompt,
    removeAdjustShoppingTagsPrompt,
    removeCropperOriginalMedia,
    setCropperZoom,
    resetCropperZoom,
    setVideoDuration,
    removeVideoDuration,
    setIsDragging,
  };
});
